import gql from 'graphql-tag'
import * as React from 'react'
import styled from 'styled-components'
import { Mutation, Query } from 'react-apollo'
import { RouteComponentProps } from 'react-router'
import Box from 'web-makeup/dist/Box'
import Form from 'web-makeup/dist/Form'
import H5 from 'web-makeup/dist/H5'
import Spin from 'web-makeup/dist/Spin'

import ProducerAbilitiesForm from '../ProducerAbilitiesForm/ProducerAbilitiesForm'
import { GetProducerProfile, UpdateProducerProfile } from '../../typings/types'
import FourOhFour from '../4xx'

import ProducerDetails from './../ProducerDetails'
import RequestTypes from './../RequestTypes'
import ServiceQualityLevels from './../ServiceQualityLevels'

const StyledBox = styled(Box)`
  padding: 2rem;
  max-width: 100%;
  margin-bottom: 1.5rem;
`

const StyledFormBox = styled(Box)`
  border: none;

  @media (min-width: 40rem) {
    border-left: none;
    border-right: none;
  }
`

export const ProducerHolder = styled.div`
  padding: 1.5rem;
`

export const GET_PRODUCER_PROFILE = gql`
  query getProducerProfile($userUuid: ID) {
    getProducerProfile(userUuid: $userUuid) {
      activated
      blockedAt
      requestTicketTypes {
        category
        subtext
        subcategory
        requestType
        title
        uuid
      }
      status
      serviceQualityLevel {
        multiplier
        name
        slug
      }
      user {
        avatar {
          cloudinaryId
          cloudinaryType
        }
        name
        email
        phoneNumber
        location {
          city
          state
          country
          googlePlaceId
        }
        dateOfBirth
        gender
        facebookProfile
        linkedinProfile
        twitterProfile
        nickname
        skypeUsername
        uuid
      }
    }
  }
`

class ProducerProfileQuery extends Query<GetProducerProfile.Query, GetProducerProfile.Variables> {}

const UPDATE_PRODUCER_PROFILE = gql`
  mutation updateProducerProfile($userUuid: ID, $producerProfile: ProducerProfileInput) {
    updateProducerProfile(userUuid: $userUuid, producerProfile: $producerProfile) {
      activated
      requestTicketTypes {
        category
        subtext
        subcategory
        requestType
        title
        uuid
      }
      serviceQualityLevel {
        multiplier
        name
        slug
      }
      user {
        uuid
      }
    }
  }
`

class ProducerProfileMutation extends Mutation<
  UpdateProducerProfile.Mutation,
  UpdateProducerProfile.Variables
> {}

export const Content = ({ loading, match, data }) =>
  loading ? (
    <Spin spinning={true}>
      <H5>Service Quality Level</H5>
      <Form.Item>
        <ServiceQualityLevels disabled />
      </Form.Item>

      <H5>Request Types</H5>
      <Form.Item>
        <RequestTypes disabled />
      </Form.Item>
    </Spin>
  ) : (
    <ProducerProfileMutation
      mutation={UPDATE_PRODUCER_PROFILE}
      refetchQueries={[
        {
          query: GET_PRODUCER_PROFILE,
          variables: { userUuid: match.params.producer_id },
        },
      ]}
    >
      {(updateProducerProfile, { loading: updating }) => (
        <ProducerAbilitiesForm
          data={data}
          onSubmit={variables => updateProducerProfile({ variables })}
          loading={updating}
        />
      )}
    </ProducerProfileMutation>
  )

type Props = RouteComponentProps<{ producer_id: string }>

export const Producer = ({ match }: Props) => (
  <ProducerProfileQuery
    query={GET_PRODUCER_PROFILE}
    variables={{ userUuid: match.params.producer_id }}
  >
    {({ loading, data }) => {
      if (!data || (data && !data.getProducerProfile && !loading)) {
        // TODO: Remove this when BE is returning a correct error
        return <FourOhFour />
      }
      return (
        <ProducerHolder>
          <StyledBox>
            <ProducerDetails
              data={data && (data.getProducerProfile as GetProducerProfile.GetProducerProfile)}
              loading={loading}
            />
          </StyledBox>
          <StyledBox>
            <StyledFormBox>
              <Content loading={loading} data={data} match={match} />
            </StyledFormBox>
          </StyledBox>
        </ProducerHolder>
      )
    }}
  </ProducerProfileQuery>
)

export default Producer



// WEBPACK FOOTER //
// ./src/components/Producer/Producer.tsx